import React, { useState, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { teamActionTypes } from '@store/Team/Team.actionTypes';
import { Input } from '@/components/Input';
import { Button } from '@/components/Button';
import styles from './Projects.module.scss';
import { textVariantsEnum, Text, fontWeightEnum } from '@/components/Text';
export const ProjectFormModal = ({ onClose, project }) => {
  const [projectName, setProjectName] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  const { activeCompany } = useSelector((state) => state.auth.profile);
  const userProfile = useSelector((state) => state.auth.profile);

  const dispatch = useDispatch();
  const handleSubmit = () => {
    if (!projectName) {
      setErrorMessage('Project Title is required');
      return;
    }
    if (project) {
      dispatch({
        type: teamActionTypes.UPDATE_PROJECT,
        payload: {
          project: projectName,
          projectId: project.projectId,
          title: projectName,
          companyId: activeCompany.companyId,
        },
      });
    } else {
      dispatch({
        type: teamActionTypes.ADD_PROJECT,
        payload: {
          project: projectName,
          companyId: activeCompany.companyId,
          createdBy: userProfile.id,
        },
      });
    }
    onClose();
  };

  return (
    <div className={styles.projectFormModal}>
      <Text
        variant={textVariantsEnum.Text_sm}
        fontWeight={fontWeightEnum.Normal}
        color="gray-700"
        className={styles.projectFormModalTitle}
      >
        {project ? 'Update Project' : 'Create Project'}
      </Text>
      <Input
        label="Project Title *"
        type="text"
        name="projectName"
        value={projectName}
        onChange={(e) => {
          setErrorMessage('');
          setProjectName(e.target.value);
        }}
        placeholder="Project Title"
        errorMessage={errorMessage}
      />
      <Button
        onClick={handleSubmit}
        text={project ? 'Update Project' : 'Create Project'}
      />
    </div>
  );
};
